"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pattern_unless_preserved = void 0;
const pattern_unless_preserved = (label, preserved) => {
    return {
        $pattern: [label, `^(?!(${preserved.join("|")})$)`],
    };
};
exports.pattern_unless_preserved = pattern_unless_preserved;
//# sourceMappingURL=pattern-unless-preserved.js.map